import dayjs from "dayjs";
import { DateString } from "seedgreen-shared/types/datestring.types";
import { NumericDateFormat } from "@/utils/locale";

/**
 * Adds days to a YYYY-MM-DD date string
 * @param dateString Date in YYYY-MM-DD format
 * @param days Number of days to add
 * @returns New date in YYYY-MM-DD format
 */
export const addDaysToDateString = (
	date: DateString,
	days: number,
): DateString => {
	return dayjs(date).add(days, "day").format("YYYY-MM-DD") as DateString;
};

/**
 * Format a DateString into a human readable format.
 *
 * Format method speficied by second param. See locale.ts for predefined formats.
 * @param date (YYYY-MM-DD)
 * @param format Intl.DateTimeFormatOptions, defaults to mm/dd/yyyy
 * @returns Formatted display string
 */
export function formatDateString(
	date: DateString | undefined,
	format: Intl.DateTimeFormatOptions = NumericDateFormat,
): string {
	if (!date) return "";
	return dayjs(date).toDate().toLocaleDateString(undefined, format);
}

/**
 * Converts a UTC date string to a local date-time string.
 * @param isoString Date in UTC format (e.g., "2023-10-01T12:00:00Z")
 * @returns Formatted date-time string in local time (e.g., "October 1, 2023 12:00 PM")
 */
export function formatUTCToLocalDateTime(isoString: string) {
	return dayjs.utc(isoString).local().format("MMMM D, YYYY h:mm A");
}
